import { render } from "./taginput.vue?vue&type=template&id=4109b401&scoped=true"
import script from "./taginput.vue?vue&type=script&lang=js"
export * from "./taginput.vue?vue&type=script&lang=js"

import "./taginput.vue?vue&type=style&index=0&id=4109b401&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4109b401"]])

export default __exports__